import io from 'socket.io-client';

const webSocket = io(process.env.REACT_APP_API_ENDPOINT, {
  extraHeaders: { "dapr-app-id": "oraq-apis-app" },
  transports: ['websocket'],
  secure: true,
  reconnection: true
});

export { webSocket };
